"use strict";
import {http} from '../../core';
const RequestService = http.create();
import Config from "../../app.config";
import store from '../../app.store'
const BASE_API = Config.BASE_API;
const RequsetSseurl=http.create({baseURL:Config.sseurl})

export default {
    getServiceCounterList:function (params) {
        return RequestService.get("home/reception",params);
    },
    getHomeList:function (params) {
        return RequestService.get("home/my_agency",params);
    },
    getNotCompleteList:function (params) {
        return RequestService.get("home/not_complete",params);
    },
    getRequestList:function (params) {
        return RequestService.get("home/my_request",params);
    },
    //搜索知识
    knowledgeQuery:function (params) {
        return RequestService.get("knowledge/query",params);
    },
    //如果另一个窗口登陆了别人账号，此窗口刷新
    updateUser(storeUser,localUser){
        // console.log(storeUser);
        // console.log(localUser);
        if (storeUser!=localUser){
            // console.log('登陆了另一个用户');
            location.reload()
        }
    },
    getMyAgencyUncompleted:function (params) {
        return RequsetSseurl.get("/v1/home/my_agency_uncompleted",params);
    },
    getReceptionOrders:function (params) {
        return RequsetSseurl.get("/v1/home/all_reception_orders",params);
    },
}
